<template>
    <v-main>
        <AppBar />
        <v-layout fill-height column>
            <v-container flex-fill fluid>
                <div class="mb-8">
                    <h1 class="fs-20">임직원 인증</h1>
                    <p class="fs-13 fw-400 subtitle--text mt-1">
                        소속확인을 위한 절차에요
                    </p>
                </div>
                <v-form class="form-item" v-model="valid">
                    <label class="label fw-600">티켓 코드</label>
                    <div class="input-group">
                        <v-text-field solo flat filled v-model="ticketCode" required :rules="code_rule" placeholder="'-'를 포함하여 입력 " maxlength="19" />
                         <v-btn elevation="0" :ripple="false" color="black" width="90" height="48" class="fs-14 white--text ml-2"  @click="btnGoAuth">인증</v-btn>
                    </div>
					<div class="px-3 mt-n2">
						<span class="lightBlue--text fs-12" v-if="valid && chkTicketCode === 0">티켓코드가 확인되었습니다.</span>
						<span class="error--text fs-12" v-else-if="chkTicketCode === 1">확인되지 않는 티켓코드 입니다.</span>
					</div>
					<div style="height: 20px;"></div>
					<label class="label fw-600">회사명</label>
					<div class="input-group">
						<v-text-field solo flat filled v-model="clientNm" required readonly placeholder="회사명 입력" />
					</div>

					<label class="label fw-600">직무</label>
					<div class="input-group">
						<v-select
							:items="jobItems"
							item-value="jobNo"
							item-text="jobName"
							v-model="selectedJob"
							required
							label="직무를 선택해주세요."
							solo
							filled
							single-line
							background-color="#F7F7F7"
							v-bind:disabled="chkTicketCode===-1" />
					</div>
					<label class="label fw-600">직급</label>
					<div class="input-group">
						<v-select
							:items="pstItems"
							item-value="pstNo"
							item-text="pstName"
							v-model="selectedPst"
							required
							label="직급를 선택해주세요."
							solo
							filled
							single-line
							background-color="#F7F7F7"
							@change="changeSelect"
							v-bind:disabled="chkTicketCode===-1" />
					</div>
                </v-form>
            </v-container>
            <div class="footer-btns">
<!--                <BlackBtn str="다음" :disabled="true"   />-->
				<BlackBtn  str="다음" :disabled="doNextChk===-1" @click="goNext" />
            </div>
        </v-layout>

    </v-main>
</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn"

import store from "@/store";

export default {
	data: () => ({

		doNextChk : -1,
		selectedJob:'',
		selectedPst:'',
		valid: false,
		authValid : false,
		ticketCode: '',
		chkTicketCode:-1,
		clientNm: '',
		clientNo:'',
		phone: '',
		jobItems: [],
		pstItems: [], //직급
    trialUser: false
	}),
	components: {
		BlackBtn,
	},
	watch : {
		ticketCode() {
			if (this.ticketCode.length <= 0) {
				this.chkTicketCode = -1;
			}
		}
	}
	,
	created() {
	},

	mounted() {
		//division 유실된경우 새로고침등 로그인 페이지로 보냄
    if (this.division == "" || this.division == undefined || this.division == null) {
			window.location.href = '/user/login'
		}
	},

	methods: {
		changeSelect() {
			return this.doNextChk = 1;
		},

		//다음 단계.
		goNext() {
      let setData = {
        jobNo: this.selectedJob,
        pstNo: this.selectedPst,
        clientNo : this.clientNo,
        ticketCd : this.ticketCode,
        trialUser: this.trialUser
      }

      store.commit('setJoinUser', setData)

      if (this.trialUser) {
        this.$router.push('/fo/join/identityAuthenticationAll');
      } else {
        this.$router.push({name:"휴대폰 인증", params: setData});
      }
		},
		isNextActive() {
			return this.doNextChk === 1;
		},
		//직급조회
		async getPstList()  {
			let outParam = {
				clientNo: this.clientNo
			};
			await store.dispatch('getPstList', this.$_payload("ctClientPst",outParam))
				.then(res => {
					if (res.success) {
						this.pstItems = res.data;
					} else {
						this.pstItems = [];
					}
				})
				.catch(error => {console.log(error)})
				.finally(() => {});
		},

		//직무조회
		async getJobList()  {
			let outParam = {
				clientNo: this.clientNo
			};

			await store.dispatch('getJobList', this.$_payload("ctClientJob", outParam))
				.then(res => {
					if(res.success) {
						this.jobItems = res.data;
					} else {
						this.jobItems = [];
					}

				}).catch(error => {
					console.error(error)
				}).finally(() => {
				});
		},

		async btnGoAuth()  {

			if(this.ticketCode==="") {
				this.$alert('티켓번호를 입력하지 않았습니다.');
				return false
			}

			await store.dispatch('getMemberAgency', this.$_payload({'ticketCode': this.ticketCode}))
				.then(res => {
					if (res.success && res.data != null) {
						this.clientNm = res.data.clientNm;
						this.clientNo = res.data.clientNo;
            this.trialUser = res.data.trialUser;
						this.chkTicketCode=0;
						this.getJobList();
						this.getPstList();
					} else {
						this.chkTicketCode=1;
					}
				}).catch(error => {
					console.log(error)
				}).finally(() => {
				});
		}
	},
	computed: {
    joinUser () {
      return store.state.memberJoin.joinUser
    },
    division () {
      return store.state.memberJoin.joinUser.division
    },
		code_rule() {
			return [
				v => !!v || '티켓코드를 올바르게 입력해주세요.',
				v => !(v && v.length > 19) || '티켓코드 -(하이픈) 포함하여 19자를 입력해주세요.',
			]
		},
	},
}
</script>
<style lang="scss" scoped>
	.lightBlue--text {
		color:blue;
	}
	.pos-relative {
		flex: 1 1 auto;
	}

	.v-input::v-deep {
		.v-text-field__details {
			padding-left: 0;
		}
	}

	.time {
		position: absolute;
		right: 8px;
		top: 14px;
		color: $color-red;
		font-size: 14px;
	}
</style>
